
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "29fef43f93687d9c7befe1d5fe284a32a39757e8",
  "nuxt": {
    "buildId": "26ca67fb-8700-46f9-91b2-641a1feabd8c"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
